import twitterIcon from "assets/img/social/twitter-icon.svg";
// import facebookIcon from "assets/img/social/facebook-icon.svg";
import instagramIcon from "assets/img/social/instagram-icon.svg";
import youtubeIcon from "assets/img/social/youtube-icon.svg";
import linkedInIcon from "assets/img/social/linkedin-icon.svg";
import pickemLogo from "assets/img/gamezone/pickem_logo.svg";
import fantasyLogo from "assets/img/gamezone/fantasy_logo.svg";
import pinpointLogo from "assets/img/gamezone/pinpoint_logo.svg";
import {ProjectName} from "data/enums";

export const SITE_URL = process.env.REACT_APP_SITE_URL || "";
export const APP_NAME = process.env.REACT_APP_NAME || "";
export const API_URL = process.env.REACT_APP_API_URL || "";
export const JSON_URL = process.env.REACT_APP_JSON_URL || "";
export const PROJECT_NAME = process.env.REACT_APP_PROJECT_NAME || "";
export const CONTENT_JSON_URL = process.env.REACT_APP_CONTENT_JSON_URL || "";
export const BASE_URL = process.env.REACT_APP_BASE_URL || "/";
export const SENTRY_DSN_URL = process.env.REACT_APP_SENTRY_DSN_URL;
export const SENTRY_ALLOW_URLS = process.env.REACT_APP_SENTRY_ALLOW_URLS?.split(",");
export const SHARE_URL = process.env.REACT_APP_SHARE_URL || "";
export const IMAGES_URL = process.env.REACT_APP_IMAGES_URL || "";

export const EMAIL_REGEXP = "\\S+@\\S+\\.\\S+";
export const PASSWORD_PATTERN =
	"^((?=.*?\\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[-!@#$%^&*()_+|~=`{}\\[\\]:\";'<>?,.\\/])).{8,}$";

export const PASSWORD_REQUIREMENTS =
	"Password must include 8 characters, including 1 upper case character, 1 number and 1 special character";

export const DATE_FORMAT = "DD-MM-YYYY";
export const DATE_PATTERN =
	"^(?:(?:(?:0[1-9]|[12]\\d|3[01])/(?:0[13578]|1[02])|(?:0[1-9]|[12]\\d|30)/(?:0[469]|11)|(?:0[1-9]|1\\d|2[0-8])/02)/(?!0000)\\d{4}|(?:(?:0[1-9]|[12]\\d)/02/(?:(?!0000)(?:[02468][048]|[13579][26])00|(?!..00)\\d{2}(?:[02468][048]|[13579][26]))))$";

export const POSTCODE_PATTERN = "^[0-9]{5}$";
export const POSTCODE_REQUIREMENTS = "Zipcode must be 5 digits";

export const CITY_PATTERN = "^[a-zA-Z\\s]+$";
export const CITY_REQUIREMENTS = "No numbers or special characters allowed";

export const LANDING_URL = "/landing";
export const GAME_PAGE_URL = "/";

export const DEFAULT_FILTER = {
	search: "",
	type: "",
};

export const SOCIAL_LINKS = [
	{
		name: "twitter",
		link: "https://twitter.com/rydercup",
		logo: twitterIcon,
	},
	{
		name: "instagram",
		link: "https://www.instagram.com/therydercup/",
		logo: instagramIcon,
	},
	{
		name: "youtube",
		link: "https://www.youtube.com/RyderCup",
		logo: youtubeIcon,
	},
	// {
	// 	name: "facebook",
	// 	link: "https://www.facebook.com/RyderCupUSA/",
	// 	logo: facebookIcon,
	// },
	{
		name: "LinkedIn",
		link: "https://www.linkedin.com/company/the-ryder-cup",
		logo: linkedInIcon,
	},
];

const HOME_PAGE_KEY = "navigation.my_predictions_copy";
const HELP_PAGE_KEY = "navigation.help_copy";
const PRIZES_PAGE_KEY = "navigation.prizes_copy";

export const MENU_LINKS = [
	{
		name: HOME_PAGE_KEY,
		url: GAME_PAGE_URL,
	},
	{
		name: PRIZES_PAGE_KEY,
		url: `/prizes`,
	},
	{
		name: HELP_PAGE_KEY,
		url: `/help`,
	},
];

export const MOBILE_MENU_LINKS = [
	{
		name: HOME_PAGE_KEY,
		url: GAME_PAGE_URL,
	},
	{
		name: PRIZES_PAGE_KEY,
		url: `/prizes`,
	},
	{
		name: HELP_PAGE_KEY,
		url: `/help`,
	},
	{
		name: "navigation.account_copy",
		url: `/my-account`,
	},
];

export const NOT_AUTH_MOBILE_MENU_LINKS = [
	{
		name: HOME_PAGE_KEY,
		url: GAME_PAGE_URL,
	},
	{
		name: PRIZES_PAGE_KEY,
		url: `/prizes`,
	},
	{
		name: "navigation.login_copy",
		url: `/login`,
	},
	{
		name: "navigation.register_copy",
		url: `/registration`,
	},
	{
		name: HELP_PAGE_KEY,
		url: `/help`,
	},
];

export const NOT_AUTH_DESKTOP_MENU_LINKS = [
	{
		name: HOME_PAGE_KEY,
		url: GAME_PAGE_URL,
	},
	{
		name: PRIZES_PAGE_KEY,
		url: `/prizes`,
	},
	{
		name: HELP_PAGE_KEY,
		url: `/help`,
	},
];

interface IGames {
	name: string;
	url: string;
	gameLogo: string;
	cardBg: string;
	title: string;
	description: string;
}

export const RYDER_CUP_GAMES: IGames[] = [
	{
		name: "Gamezone",
		url: "/",
		gameLogo: pickemLogo,
		cardBg: "",
		title: "1111who will make tour team?",
		description:
			"111Select 12 golfers for Team Europe and Team USA to build out your Ryder Cup Team",
	},
	{
		name: "Fantasy",
		url: "/fantasy/",
		gameLogo: fantasyLogo,
		cardBg: "",
		title: "222who will make tour team?",
		description:
			"222Select 12 golfers for Team Europe and Team USA to build out your Ryder Cup Team",
	},
	{
		name: "Pinpoint",
		url: "/pinpoint/",
		gameLogo: pinpointLogo,
		cardBg: "",
		title: "333who will make tour team?",
		description:
			"333Select 12 golfers for Team Europe and Team USA to build out your Ryder Cup Team",
	},
];

export interface ISubNavigationItem {
	name: string;
	to: string;
	href: string;
	hidden?: boolean;
	hiddenPaths?: string[];
	authorizationRequired?: boolean;
	subItems?: ISubNavigationItem[];
	projectName?: ProjectName;
	customClass?: string;
	isDropdown?: boolean;
}

export const PROJECTS_NAVIGATION_ITEMS: ISubNavigationItem[] = [
	{
		name: "subheader.game.gamezone",
		to: "/",
		href: SITE_URL,
		projectName: ProjectName.Gamezone,
	},
	{
		name: "subheader.game.pickem",
		to: "/",
		href: `${SITE_URL}your-picks/`,
		projectName: ProjectName.Pickem,
	},
	{
		name: "subheader.game.fantasy",
		to: "/",
		href: `${SITE_URL}fantasy/`,
		projectName: ProjectName.Fantasy,
	},
	{
		name: "subheader.game.pinpoint",
		to: "/",
		href: `${SITE_URL}pinpoint/`,
		projectName: ProjectName.Pinpoint,
	},
];

export const LONGEST_DRIVE_OPTIONS = [
	{
		label: "260 - 269",
		value: "260,269",
	},
	{
		label: "270 - 279",
		value: "270,279",
	},
	{
		label: "280 - 289",
		value: "280,289",
	},
	{
		label: "290 - 299",
		value: "290,299",
	},
	{
		label: "300 - 309",
		value: "300,309",
	},
	{
		label: "310 - 319",
		value: "310,319",
	},
	{
		label: "320 - 329",
		value: "320,329",
	},
	{
		label: "330 - 339",
		value: "330,339",
	},
	{
		label: "340 - 349",
		value: "340,349",
	},
	{
		label: "> 349",
		value: "349,",
	},
];

export const NEAREST_PIN_OPTIONS = [
	{
		label: `0-4'11"`,
		value: "0,5",
	},
	{
		label: `5-9'11"`,
		value: "5,10",
	},
	{
		label: `10-14'11"`,
		value: "10,15",
	},
	{
		label: `15-19'11"`,
		value: "15,20",
	},
	{
		label: "> 20'",
		value: "20,",
	},
];

export const LOCAL_STORAGE_PICK_KEY = "pinpointPick";

export const IS_SINGLE_PLAYER_VALUE = "saturday pm four-balls";

export const WEBVIEW = sessionStorage.getItem("webview") === "true";
